import { appConfig } from "../app-config.ts"

export const HeaderLogo = () => (
  <img
    style={{ width: `${appConfig.assets.images.logo.width}px` }}
    className="mt-6 mx-auto"
    src={appConfig.assets.images.logo.url}
    alt={`${appConfig.artist.name} logo`}
  />
)
